/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigurationView } from './ConfigurationView';
import {
    ConfigurationViewFromJSON,
    ConfigurationViewFromJSONTyped,
    ConfigurationViewToJSON,
    ConfigurationViewToJSONTyped,
} from './ConfigurationView';

/**
 * 
 * @export
 * @interface GetConfiguration200Response
 */
export interface GetConfiguration200Response {
    /**
     * 
     */
    data?: ConfigurationView;
}

/**
 * Check if a given object implements the GetConfiguration200Response interface.
 */
export function instanceOfGetConfiguration200Response(value: object): value is GetConfiguration200Response {
    return true;
}

export function GetConfiguration200ResponseFromJSON(json: any): GetConfiguration200Response {
    return GetConfiguration200ResponseFromJSONTyped(json, false);
}

export function GetConfiguration200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfiguration200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ConfigurationViewFromJSON(json['data']),
    };
}

export function GetConfiguration200ResponseToJSON(json: any): GetConfiguration200Response {
    return GetConfiguration200ResponseToJSONTyped(json, false);
}

export function GetConfiguration200ResponseToJSONTyped(value?: GetConfiguration200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ConfigurationViewToJSON(value['data']),
    };
}

